import { ChangelogResponse, ChangelogResponseItem } from '@/types/service-response'
import moment from 'moment'

export class Changelog {
  private constructor (
    readonly id: number,
    readonly version: string,
    readonly summary: string[],
    readonly releaseDate: string,
    readonly changed: string
  ) {}

  static createFromResponse (responseData: ChangelogResponse): Array<Changelog> {
    return responseData.map((item: ChangelogResponseItem) => {

      return new Changelog(
        item.ID,
        item.Version ? item.Version : '',
        item.Summary ? item.Summary : [],
        item.ReleaseDate ? moment(item.ReleaseDate, 'DD.MM.YYYY HH:mm:ss'). format('DD.MM.YYYY HH:mm') : '',
        item.Changed ? item.Changed : ''
      )
    })
  }
}
